import { useState, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { RegionFilterDropdown } from '@/features/geo-area/components/region/RegionFilterDropdown';
import {
  DEFAULT_EVENTS_RADIUS_KM,
  getEventsRadiusFilters
} from '@/features/geo-area/components/region/regionOptions';
import {
  RegionTab,
  type RegionFilterChange
} from '@/features/geo-area/components/region/regionTypes';
import { LocalizationNameSpace } from '@/localization/types/localizationTypes';

export const EventsFilter: FC<{
  onChange: (change: RegionFilterChange) => void;
}> = ({ onChange }) => {
  const { t } = useTranslation(LocalizationNameSpace.GEO_AREA, {
    keyPrefix: 'screens.myRegion'
  });
  const [radiusKm, setRadiusKm] = useState(DEFAULT_EVENTS_RADIUS_KM);

  const onSelect = (value: number) => {
    setRadiusKm(value);
    onChange({ tab: RegionTab.EVENTS, radiusKm: value });
  };

  return (
    <RegionFilterDropdown<number>
      options={getEventsRadiusFilters(t)}
      value={radiusKm}
      onSelect={onSelect}
    />
  );
};
